import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const experiencesSelectDefaultVariants = {}
const experiencesSelectCompoundVariants = []

const experiencesSelectSlotNames = [
  [
    "stack",
    "ExperiencesSelect__stack"
  ],
  [
    "item",
    "ExperiencesSelect__item"
  ],
  [
    "overflow",
    "ExperiencesSelect__overflow"
  ]
]
const experiencesSelectSlotFns = /* @__PURE__ */ experiencesSelectSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, experiencesSelectDefaultVariants, getSlotCompoundVariant(experiencesSelectCompoundVariants, slotName))])

const experiencesSelectFn = memo((props = {}) => {
  return Object.fromEntries(experiencesSelectSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const experiencesSelectVariantKeys = []
const getVariantProps = (variants) => ({ ...experiencesSelectDefaultVariants, ...compact(variants) })

export const experiencesSelect = /* @__PURE__ */ Object.assign(experiencesSelectFn, {
  __recipe__: false,
  __name__: 'experiencesSelect',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: experiencesSelectVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, experiencesSelectVariantKeys)
  },
  getVariantProps
})